import { TREND_PCT_CEILING } from "@/v2-backoffice-client/usage/usage.constants"

/** "a", "a and b", "a, b and c" — the prose joiner every usage story uses. */
export function list(items: string[]) {
  if (items.length <= 1) return items.join("")
  return `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`
}

/**
 * "up 23 %", "down 56 %", "level", or "up from almost nothing" when the
 * previous window was near zero and a percentage would mislead.
 */
export function describeTrend(trendPct: number) {
  if (trendPct >= TREND_PCT_CEILING) return "up from almost nothing"
  if (trendPct > 0) return `up ${Math.round(trendPct)} %`
  if (trendPct < 0) return `down ${Math.abs(Math.round(trendPct))} %`
  return "level"
}

/** A rounded share for prose: "38 %", and "under 1 %" instead of "0 %". */
export function formatShare(pct: number) {
  return pct < 1 ? "under 1 %" : `${pct} %`
}
